import MFEContainer from "./containers/MFEContainer";
import { UserInfo } from "./types/UserInfo";
import UserContext from "./contexts/UserContext";
import { MixPanelType } from "./types/CommonTypes";
import FundHoldingDetails from "./views/FundHoldingDetails";
import { FundHoldingDetailsProps } from "./components/FundHoldingsTable";

export interface Props extends FundHoldingDetailsProps {
  language: string;
  userInfo: UserInfo;
  MixPanel: MixPanelType;
}

function App({ language, userInfo, MixPanel, tokenId }: Props) {
  return (
    <MFEContainer language={language} MixPanel={MixPanel}>
      <UserContext userInfo={userInfo}>
        <FundHoldingDetails tokenId={tokenId} />
      </UserContext>
    </MFEContainer>
  );
}

export default App;
